import { baseFetch } from './baseFetch';

export const jsonFetch = (url, options) => {
  options.headers = options.headers || {};
  options.headers.Accept = options.headers.Accept || 'application/json';
  // NB: a 204-status would imply no body, so res.json will fails; need to manually return
  //     the empty payload
  return baseFetch(url, options).then(res => (res.status === 204 ? {} : res.json()));
};